var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPointerOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EE4320",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.016 25c-.78 0-1.27.852-.878 1.533l3.984 6.956a1.01 1.01 0 0 0 1.756 0l3.985-6.956c.39-.681-.098-1.533-.879-1.533H8.016zM16.417 14.457c0 1.08-.88 1.96-1.96 1.96H9.544a1.963 1.963 0 0 1-1.961-1.96V9.543c0-1.08.88-1.96 1.96-1.96h4.914c1.08 0 1.96.88 1.96 1.96v4.914zM6.927 0A6.928 6.928 0 0 0 0 6.927v10.146A6.928 6.928 0 0 0 6.928 24h10.145A6.927 6.927 0 0 0 24 17.073V6.927A6.927 6.927 0 0 0 17.073 0H6.928z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointerOrange);
export default __webpack_public_path__ + "static/media/location_pointer_orange.09f1afe579577eff95b093117f087fa6.svg";
export { ForwardRef as ReactComponent };